/*--------------------------------------------------------
 * Author Trần Đức Tiến
 * Email ductienas@gmail.com
 * Phone 0972970075
 * Created: 2017-05-28 13:00:39
 *
 * LastModified: 2017-05-28 13:00:39
 *-------------------------------------------------------*/

// const API_SERVER = process.env.NODE_ENV === 'production' ? '/' : 'http://localhost:3000/'
const API_SERVER = 'https://glasson.sk-global.biz/'

const APPCONFIG = {
  brand: 'GlassOn',
  year: new Date().getFullYear(),
  paypalUrlCallback: {
    // cancelUrl: 'http://192.168.1.145:3000/#/checkout/cancel',
    // returnUrl: 'http://192.168.1.145:3000/#/checkout/execute',
    cancelUrl: API_SERVER + '#/checkout/cancel',
    returnUrl: API_SERVER + '#/checkout/execute'
  },
  API_SERVER,
  API_HOST: API_SERVER + 'api/v2/',
  API_IMG: API_SERVER + 'images/',
  URL_PLUGIN: API_SERVER + 'plugin.js',
  THEMA_ID: 38,
  // THEMA_ID: process.env.NODE_ENV === 'production' ? 38 : 3,
  GREENVISION_ID: process.env.NODE_ENV === 'production' ? 41 : 3,
  OWNDAYS_ID: process.env.NODE_ENV === 'production' ? 42 : 3,
  EYESTYLE_ID: process.env.NODE_ENV === 'production' ? 44 : 3,
  BRAVO_ID: process.env.NODE_ENV === 'production' ? 45 : 3,
  FIRECOALS_ID: process.env.NODE_ENV === 'production' ? 64 : 3,
  GOOGLE_MAPS_API_KEY: 'AIzaSyBl6Q18pt3Waw2c-ugzsjpW0kgmTAJUxCA',
  productLink: 'https://glasson.sk-global.biz',
  AutoCloseMobileNav: true, // true, false. Automatically close sidenav on route change (Mobile only)
  PRICE_GOLD: 9980,
  uploadLimit: {
    store: 5,
    gold: 100,
    enterprise: 1000
  },
  color: {
    primary: '#2196F3',
    success: '#8BC34A',
    info: '#66BB6A',
    infoAlt: '#7E57C2',
    warning: '#FFCA28',
    danger: '#F44336',
    text: '#3D4051',
    gray: '#EDF0F1'
  },
  settings: {
    layoutBoxed: false, // true, false
    navCollapsed: false, // true, false
    navBehind: false, // true, false
    fixedHeader: true, // true, false
    sidebarWidth: 'small', // small, middle, large
    colorOption: '11', // String: 11,12,13,14,15,16; 21,22,23,24,25,26; 31,32,33,34,35,36
    theme: 'light' // light, gray, dark
  },
  // glassesType: ['eyeglasses', 'sunglasses', 'sportglasses', 'other'],
  glassesType: ['eyeglasses', 'sunglasses', 'clipon'],
  frameType: ['full_frame', 'semi_rimless', 'rimless', 'other'],
  // frameShape: ['square', 'rectangle', 'wayframe', 'oval',
  //   'wrap', 'aviator', 'cateye', 'round', 'browline',
  //   'wellington', 'boston', 'nose_pad', 'oversized',
  //   'geometric', 'butterfly', 'other'],
  frameShape: ['aviator', 'cateye', 'oval', 'rectangle', 'round', 'square'],
  // material: ['metal', 'plastic', 'metal_plastic', 'resin',
  //   'celluloid', 'titanium', 'stainless', 'other'],
  material: ['3dacetate', 'acetate', 'combined', 'metal', 'titanium', 'tr-90', 'ultem'],
  currency: ['USD', 'VND'],
  paymentType: ['All', 'International bank', 'Domestic bank', 'Paypal'],
  status: ['trial', 'active', 'deactive'],
  country: ['All', 'VN', 'JP', 'US'],
  color: [
    'black',
    'blue',
    'brown',
    'cream',
    'gold',
    'gray',
    'green',
    'orange',
    'pink',
    'red',
    'violet',
    'white',
    'yellow',
    'gunmetal',
    'havana',
    'metal',
    'multicolor',
    'pattern'
  ],
  locale: {
    // https://docs.oracle.com/cd/E13214_01/wli/docs92/xref/xqisocodes.html
    country: ['JP', 'AU', 'KH', 'CN', 'FR', 'DE', 'IN', 'ID', 'IT', 'MY', 'PH', 'RU', 'SG', 'ES', 'TW', 'TH', 'GB', 'US', 'VN'],
    lang: ['ja', 'zh', 'en', 'fr', 'de', 'hi', 'id', 'it', 'km', 'ru', 'es', 'th', 'vi'],
    currency: ['JPY', 'AUD', 'CNY', 'EUR', 'GBP', 'IDR', 'INR', 'MYR', 'PHP', 'RUB', 'RUR', 'SGD', 'THB', 'USD', 'VND'],
    flag: {
      JP: '/assets/images/flag_jp.png',
      AU: '/assets/images/flag_au.png',
      KH: '/assets/images/flag_kh.png',
      CN: '/assets/images/flag_cn.png',
      FR: '/assets/images/flag_fr.png',
      DE: '/assets/images/flag_de.png',
      IN: '/assets/images/flag_in.png',
      ID: '/assets/images/flag_id.png',
      IT: '/assets/images/flag_it.png',
      MY: '/assets/images/flag_my.png',
      PH: '/assets/images/flag_ph.png',
      RU: '/assets/images/flag_ru.png',
      SG: '/assets/images/flag_sg.png',
      ES: '/assets/images/flag_es.png',
      TW: '/assets/images/flag_tw.png',
      TH: '/assets/images/flag_th.png',
      GB: '/assets/images/flag_gb.png',
      US: '/assets/images/flag_us.png',
      VN: '/assets/images/flag_vn.png'
    }
  },
  /*eslint no-useless-escape:0*/
  formatEmail: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  formatPhoneNumber: /^[0-9]+$/,
  formatUrl: /^(?:(?:https?|ftp):\/\/)(?:\S+(?::\S*)?@)?(?:(?!(?:10|127)(?:\.\d{1,3}){3})(?!(?:169\.254|192\.168)(?:\.\d{1,3}){2})(?!172\.(?:1[6-9]|2\d|3[0-1])(?:\.\d{1,3}){2})(?:[1-9]\d?|1\d\d|2[01]\d|22[0-3])(?:\.(?:1?\d{1,2}|2[0-4]\d|25[0-5])){2}(?:\.(?:[1-9]\d?|1\d\d|2[0-4]\d|25[0-4]))|(?:(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)(?:\.(?:[a-z\u00a1-\uffff0-9]-*)*[a-z\u00a1-\uffff0-9]+)*(?:\.(?:[a-z\u00a1-\uffff]{2,}))\.?)(?::\d{2,5})?(?:[/?#]\S*)?$/i
}

// AWS S3
const S3_BUCKET = process.env.NODE_ENV === 'production' ? 'production-glasson' : 'glasson-stg'
APPCONFIG.S3_URL = `https://${S3_BUCKET}.s3.ap-northeast-1.amazonaws.com`
APPCONFIG.S3_BUCKET = S3_BUCKET

module.exports = APPCONFIG



// WEBPACK FOOTER //
// ./constants/Config.js